export class HealthcheckManager {
    constructor() {
        this.healthchecks = new Map();
    }
    registerHealthcheck(type, healthcheck) {
        this.healthchecks.set(type, healthcheck);
    }
    getHealthcheck(type) {
        const healthcheck = this.healthchecks.get(type);
        if (!healthcheck) {
            throw new Error(`Healthcheck for type ${type} not found`);
        }
        return healthcheck;
    }
    async ping(type) {
        await this.getHealthcheck(type).ping();
    }
}
//# sourceMappingURL=HealthcheckManager.js.map